// extracted by mini-css-extract-plugin
export default {"container":"NumberList_container__QY44s"};